
// **** Better way to set special products in one place **** ////
var specialProduct1 = false;
var specialProduct2 = false;
var specialProduct3 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('Black Friday'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 
}

var t = new Date()
var currentDay = t.getDate();
var currentMonth = t.getMonth();
var currentyear = t.getFullYear();
var weekDay = t.getDay();
var currentHour = t.getHours()

var crDeliveryDateCallback = function(picker, blackoutdatesCollection){
  if (weekDay == 5 && currentHour >= 15) {
    picker.set('min', 3); 
  } 
  picker.set('disable', blackoutdatesCollection);
}

var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  if (specialProduct1 === true) {
  	picker.set('disable', [true, 
        { from: [2020, 8, 10], to: [2025, 10, 27] }, 
        { from: [2025, 10, 29], to: [2042, 9, 7] }
    ]);
    picker.set('max', 100);   
  }	else {
    picker.set('disable', blackoutdatesCollection);
  }  
}